import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter, switchMap, distinctUntilChanged } from 'rxjs/operators';
import { of, Subscription, merge, Observable } from 'rxjs';
import $ from 'jquery';
import { Store } from '@ngxs/store';
import { UpdateMarkets } from 'src/app/store/actions/bets.action';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LangService } from '@services/lang.service';

import { TournamentService } from '../../services/tournament.service';
import { UtilsService } from '../../services/utils.service';
import { has } from 'lodash-es';

@Component({
    selector: 'app-page-stage',
    templateUrl: './page-stage.component.html',
})
export class PageStageComponent implements OnInit, OnDestroy {
    public sportId: number | null = null;

    public sportName: string;

    public categoryId: number | null = null;

    public date: string | null = null;

    private subscripton: Subscription;

    public constructor(
        private router: ActivatedRoute,
        private route: Router,
        private store: Store,
        private tournament: TournamentService,
        public deviceService: DeviceDetectorService,
        private lang: LangService,
    ) {}

    public ngOnInit(): void {
        const one = this.route.events.pipe(
            filter((event): boolean => event instanceof NavigationEnd),
            switchMap(
                (): Observable<any> => (this.router.firstChild && this.router.firstChild.params) ||
                    of({}),
            ),
            distinctUntilChanged(),
        );

        const two = this.router.firstChild!.paramMap.pipe(
            switchMap((p): Observable<any> => of(p)),
        );

        this.subscripton = merge(one, two).subscribe((val: any): void => {
            if (val.get !== undefined) {
                if (val.has('sport')) {
                    [this.sportId, this.sportName] = UtilsService.parseSportUrl(
                        val.get('sport'),
                    );
                }
                if (val.has('date')) {
                    this.date = val.get('date');
                }
            } else {
                if (has(val, 'sport')) {
                    [this.sportId, this.sportName] = UtilsService.parseSportUrl(
                        val.sport,
                    );
                }
                if (has(val, 'date')) {
                    this.date = val.date;
                }
            }
        });


        this.store.dispatch(new UpdateMarkets());

        // TODO workaround push notification translation not working on stage sports
        $('#push-notification').hide();
    }

    public ngOnDestroy(): void {
        this.subscripton.unsubscribe();
    }
}
